var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLoginDecorLeft = function SvgLoginDecorLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 560,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#AFDECE",
    d: "M0 .5c19.882 0 36 16.118 36 36V232c0 19.882-16.118 36-36 36V.5ZM0 292c19.882 0 36 16.118 36 36v195.5c0 19.882-16.118 36-36 36V292Z"
  })));
};
export { SvgLoginDecorLeft as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iNTYwIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik0wIC41YzE5Ljg4MjIgMCAzNiAxNi4xMTc3IDM2IDM2VjIzMmMwIDE5Ljg4Mi0xNi4xMTc4IDM2LTM2IDM2Vi41Wk0wIDI5MmMxOS44ODIyIDAgMzYgMTYuMTE4IDM2IDM2djE5NS41YzAgMTkuODgyLTE2LjExNzggMzYtMzYgMzZWMjkyWiIgZmlsbD0iI0FGREVDRSIvPjwvc3ZnPg==";